import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconEnvelopeTimes: React.FC<Props> = ({
  width = 24,
  height = 24,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5 16.74C12.62 13.95 14.95 11.63 17.74 11.51C18.39 11.48 19.0201 11.56 19.6001 11.74C19.8001 11.8 20 11.67 20 11.46V7C20 5 19 4 17 4H5C3 4 2 5 2 7V16C2 18 3 19 5 19H12.46C12.66 19 12.8 18.8 12.73 18.61C12.55 18.02 12.47 17.4 12.5 16.74ZM12.0291 12.179C11.7211 12.403 11.36 12.515 11 12.515C10.64 12.515 10.2779 12.403 9.97095 12.18L5.05908 8.60699C4.72408 8.36399 4.65004 7.89401 4.89404 7.55901C5.13604 7.22501 5.60489 7.149 5.94189 7.394L10.854 10.966C10.942 11.029 11.059 11.03 11.147 10.966L16.0591 7.394C16.3961 7.149 16.8649 7.22501 17.1069 7.55901C17.3509 7.89401 17.2769 8.36299 16.9419 8.60699L12.0291 12.179ZM18 13C15.791 13 14 14.791 14 17C14 19.209 15.791 21 18 21C20.209 21 22 19.209 22 17C22 14.791 20.209 13 18 13ZM19.354 17.646C19.549 17.841 19.549 18.158 19.354 18.353C19.256 18.451 19.128 18.499 19 18.499C18.872 18.499 18.744 18.45 18.646 18.353L18 17.707L17.354 18.353C17.256 18.451 17.128 18.499 17 18.499C16.872 18.499 16.744 18.45 16.646 18.353C16.451 18.158 16.451 17.841 16.646 17.646L17.292 17L16.646 16.354C16.451 16.159 16.451 15.842 16.646 15.647C16.841 15.452 17.158 15.452 17.353 15.647L17.999 16.293L18.645 15.647C18.84 15.452 19.1571 15.452 19.3521 15.647C19.5471 15.842 19.5471 16.159 19.3521 16.354L18.7061 17L19.354 17.646Z"
      fill={color}
    />
  </svg>
);

export default IconEnvelopeTimes;
